import * as inviteUserActionTypes from './constants'

/**
 *
 */
function getInitialState() {
	return {
		inProgress: false,
		isError: false,
		invalidEmail: false,
	}
}

const inviteUserReducer = (state = getInitialState(), action) => {
	switch (action.type) {
		case inviteUserActionTypes.INVITE_USER_REQUEST: {
			return {
				...state,
				inProgress: true,
				isError: false,
				invalidEmail: false,
			}
		}
		case inviteUserActionTypes.INVITE_USER_SUCCESS:
		case inviteUserActionTypes.INVITE_USER_RESET:
			return getInitialState()
		case inviteUserActionTypes.INVITE_USER_ERROR: {
			return {
				...state,
				inProgress: false,
				isError: true,
				invalidEmail: false,
			}
		}
		case inviteUserActionTypes.INVITE_USER_INVALID_EMAIL: {
			return {
				...state,
				inProgress: false,
				isError: false,
				invalidEmail: true,
			}
		}
		default: {
			return state
		}
	}
}

export default inviteUserReducer
